import LayoutWrapper from "src/components/Wrapper/LayoutWrapper";
import ThemeWrapper from "src/components/Wrapper/ThemeWrapper";
import RouteApp from "./RouteApp";

export default function WrapperApp() {
  return (
    <ThemeWrapper>
      <LayoutWrapper>
        <RouteApp />
      </LayoutWrapper>
    </ThemeWrapper>
  );
}
